"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.upgrade = void 0;
const Account_1 = __importDefault(require("./Account"));
const nep2_1 = require("./nep2");
const consts_1 = require("../consts");
/**
 * Upgrades a Neo2 account to a Neo3 account. If an encrypted account is provided, the returned account is also encrypted with the same passphrase.
 */
async function upgrade(account, passphrase = "", scryptParams = consts_1.DEFAULT_SCRYPT) {
    // Checks that account is upgradable
    if (!account.tryGet("privateKey") && passphrase === "") {
        throw new Error(`The account needs an unencrypted private key.`);
    }
    // Check if address is neo2 style (Starts with A)
    if (!account.address.startsWith("A")) {
        throw new Error(`This is not a neo2 Address.`);
    }
    if (passphrase) {
        const wifKey = await (0, nep2_1.decryptNeo2)(account.encrypted, passphrase, scryptParams);
        const neo3Account = new Account_1.default(wifKey);
        return await neo3Account.encrypt(passphrase, scryptParams);
    }
    const wifKey = account.WIF;
    const neo3Account = new Account_1.default(wifKey);
    return neo3Account;
}
exports.upgrade = upgrade;
